import { render, staticRenderFns } from "./BestInterestsOfChild.vue?vue&type=template&id=f5494aa2"
import script from "./BestInterestsOfChild.vue?vue&type=script&lang=ts"
export * from "./BestInterestsOfChild.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports